import { Card, Col, DatePicker, Empty, Row, Select, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import {
  ActivityRewardStatus,
  GSLMActivityJoinedRecordWithStatus,
  MarketingActivity,
} from '../../types/marketingActivity';

export const USER_SLM_JOINED_RECORDS_QUERY = gql`
  query GetUserSlmRecords($ids: [ID], $activityId: ID) {
    users(ids: $ids) {
      slmActivityJoinedRecords(activityId: $activityId) {
        sourceId
        quantity
        status
        scheduledTime
        fundedAt
        createdAt
      }
    }
  }
`;

interface Props {
  userId: number;
  marketingActivityFilterOptions: MarketingActivity[];
}

interface State {
  checkInAt: moment.Moment;
  slmDateRange: DateRange;
  selectedMarketingActivityFilter: number;
}

export class SlmRecords extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      checkInAt: moment(),
      slmDateRange: {
        from: moment().subtract(6, 'days').toDate(),
        to: new Date(),
      },
      selectedMarketingActivityFilter: 0,
    };
  }
  getSLMList(slmActivityJoinedRecords: GSLMActivityJoinedRecordWithStatus[], loading: boolean) {
    const { slmDateRange } = this.state;
    const from = moment(slmDateRange.from);
    const to = moment(slmDateRange.to);

    const slmActivityJoinedRecordsInDateRange = slmActivityJoinedRecords.filter(slmActivityJoinedRecord =>
      moment(slmActivityJoinedRecord.fundedAt).isBetween(from, to),
    );

    return (
      <Table<GSLMActivityJoinedRecordWithStatus>
        columns={[
          {
            title: '日期',
            key: 'date',
            render: record => moment(record && record.fundedAt).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            title: '积分状态',
            key: 'status',
            render: record => {
              if (record.status === ActivityRewardStatus.SCHEDULED) {
                return '待发放';
              }
              return '已发放';
            },
          },
          {
            title: '积分数量',
            key: 'quantity',
            render: record => record.quantity || 0,
          },
          {
            title: '来源',
            key: 'from',
            render: () => '分销',
          },
        ]}
        loading={loading}
        dataSource={slmActivityJoinedRecordsInDateRange}
        rowKey={record => `${record.fundedAt}`}
        pagination={false}
      />
    );
  }

  getSLMSentPoint(slmActivityJoinedRecords: GSLMActivityJoinedRecordWithStatus[]) {
    let enrnedPoint = 0;
    for (const slmActivityJoinedRecord of slmActivityJoinedRecords) {
      if (slmActivityJoinedRecord.status === ActivityRewardStatus.SENT) {
        enrnedPoint += Number(slmActivityJoinedRecord.quantity);
      }
    }
    return enrnedPoint;
  }
  getSLMPendingPoint(slmActivityJoinedRecords: GSLMActivityJoinedRecordWithStatus[]) {
    let pendingPoint = 0;
    for (const slmActivityJoinedRecord of slmActivityJoinedRecords) {
      if (slmActivityJoinedRecord.status === ActivityRewardStatus.SCHEDULED) {
        pendingPoint += Number(slmActivityJoinedRecord.quantity);
      }
    }
    return pendingPoint;
  }
  render() {
    const { userId, marketingActivityFilterOptions } = this.props;
    const { selectedMarketingActivityFilter, slmDateRange } = this.state;
    if (!marketingActivityFilterOptions.length) {
      return null;
    }
    const ids = [Number(userId)];
    const activityId = marketingActivityFilterOptions[selectedMarketingActivityFilter].id;
    return (
      <Query query={USER_SLM_JOINED_RECORDS_QUERY} variables={{ ids, activityId }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users || {};
          const slmActivityJoinedRecords = (user && user.slmActivityJoinedRecords) || [];
          return (
            <div>
              <Card bordered={false}>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    推广已发积分
                  </Col>
                  <Col span={7}>{this.getSLMSentPoint(slmActivityJoinedRecords)}</Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    推广待发积分
                  </Col>
                  <Col span={7}>{this.getSLMPendingPoint(slmActivityJoinedRecords)}</Col>
                </Row>
                <Row gutter={24} style={{ marginTop: 10 }}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    活动：
                  </Col>
                  <Col span={19}>
                    <Select
                      style={{ width: '150px' }}
                      defaultValue={marketingActivityFilterOptions[selectedMarketingActivityFilter].name}
                      onChange={value => {
                        this.setState({
                          selectedMarketingActivityFilter: Number(value),
                        });
                      }}
                    >
                      {marketingActivityFilterOptions.map((option, index) => (
                        <Select.Option value={index} key={`${index}`}>
                          {option.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
                <Row gutter={24} style={{ marginTop: 10 }}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    筛选时间
                  </Col>
                  <Col span={19}>
                    <DatePicker.RangePicker
                      value={[moment(slmDateRange.from), moment(slmDateRange.to)]}
                      ranges={{
                        今天: [moment(), moment()],
                        本周: [moment().startOf('week'), moment().endOf('week')],
                        上周: [
                          moment().startOf('week').subtract(1, 'week'),
                          moment().endOf('week').subtract(1, 'week'),
                        ],
                      }}
                      onChange={dates =>
                        this.setState({
                          slmDateRange: {
                            from: moment(dates[0]).startOf('day').toDate(),
                            to: moment(dates[1]).endOf('day').toDate(),
                          },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Card>
              {this.getSLMList(slmActivityJoinedRecords, loading)}
            </div>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/SlmRecords.tsx